'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Component } from 'react';
import ResultHeader from './ResultHeader';
import ResultInfo from './ResultInfo';
import ResultSection from './ResultSection';
import Tag from './Tag';

var IconResultSection = /*#__PURE__*/function (_Component) {
  _inherits(IconResultSection, _Component);

  function IconResultSection() {
    _classCallCheck(this, IconResultSection);

    return _possibleConstructorReturn(this, _getPrototypeOf(IconResultSection).apply(this, arguments));
  }

  _createClass(IconResultSection, [{
    key: "render",
    value: function render() {
      var props = this.props;
      return /*#__PURE__*/_jsxs(ResultSection, {
        gradeType: props.gradeType,
        children: [/*#__PURE__*/_jsx(Tag, Object.assign({}, props)), /*#__PURE__*/_jsx(ResultHeader, Object.assign({}, props)), /*#__PURE__*/_jsx("div", {
          className: "result-icon icon " + props.resultIcon
        }), /*#__PURE__*/_jsx(ResultInfo, Object.assign({}, props))]
      });
    }
  }]);

  return IconResultSection;
}(Component);

IconResultSection.propTypes = {
  gradeType: PropTypes.string,
  resultHeader: PropTypes.string,
  resultIcon: PropTypes.string
};
export { IconResultSection as default };